import { Image } from "antd";

export default function LayoutFooterComponent({}) {
  return (
    <div className="mt-[600px] h-[212px] table-mng-footer-bg">
      <div className="flex items-center justify-between pl-[130px] pr-[50px]">
        {/* kitchen */}
        <div className="max-w-[379px] w-full h-[165px] mt-5 bg-[#FAD709] rounded-[20px] flex items-center justify-center">
          <div className="flex items-center space-x-3">
            <Image src={"/images/icons/kitchen.svg"} preview={false} />
            <h1 className="font-p_medium text-[30px] leading-[46px]">Kitchen</h1>
          </div>
        </div>
        {/* entry */}
        <div className="max-w-[221px] w-full h-[135px] mt-20 bg-white rounded-full flex items-center justify-center">
          <h1 className="font-p_medium text-[30px] leading-[46px]">Entry</h1>
        </div>
        {/* washroom */}
        <div className="max-w-[379px] w-full h-[165px] mt-5 bg-[#FAD709] rounded-[20px] relative">
          <div className="flex items-center justify-around absolute w-full top-[-20px] left-0 px-4">
            <div className="w-[55px] h-[54px] bg-white border border-black rounded-full"></div>
            <div className="w-[55px] h-[54px] bg-white border border-black rounded-full"></div>
            <div className="w-[55px] h-[54px] bg-white border border-black rounded-full"></div>
          </div>
          <div className="flex items-center justify-center h-full font-p_medium text-[30px] leading-[46px]">
            Washroom
          </div>
        </div>
      </div>
    </div>
  );
}
